<template>
    <div class="relative" v-bind:class="{ 'opacity-0': !initialized }" ref="dropdownTags">
        <div @click="toggle()" :class="{ 'z-20': open, 'z-0': !open }" ref="trigger">
            <slot name="trigger"></slot>
        </div>

        <!-- Full Screen Dropdown Overlay -->
        <!-- <div v-show="open" class="fixed inset-0 z-10" @click="open = false">
        </div> -->

        <transition enter-active-class="transition ease-out duration-200"
            enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">
            <div v-show="open"
                class="absolute bottom-12 top-auto mt-2 rounded-md shadow-lg w-44 tagsMenu max-h-[30vh] overflow-hidden"
                :class="[widthClass, alignmentClasses, zClasses, heightClasses]" style="display: none;" id="tagsMenu"
                @click="clickInside" v-click-outside="vcoConfig" ref="panel">

                <div class=" rounded-md ring-1 ring-black ring-opacity-5 overflow-y-auto max-h-[calc(30vh-2rem)]"
                    :class="contentClasses">
                    <slot name="content"></slot>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
import { watch, onMounted, onUnmounted, ref } from "vue";

export default {
    props: {
        align: {
            default: 'right'
        },
        width: {
            default: '48'
        },
        contentClasses: {
            default: () => ['py-2', 'bg-white']
        },
        closeOnClickInside: {
            default: true
        }
    },
    data() {
        return {
            lastOpen: 0,
            lastClickInside: 0,
            initialized: true,
            // originalTop: -999
            vcoConfig: {
                handler: this.clickOutsideHandler,
                middleware: this.clickOutside,
                events: ['dblclick', 'click'],
                // Note: The default value is true, but in case you want to activate / deactivate
                //       this directive dynamically use this attribute.
                isActive: true,
                // Note: The default value is true. See "Detecting Iframe Clicks" section
                //       to understand why this behaviour is behind a flag.
                detectIFrame: false,
                // Note: The default value is false. Sets the capture option for EventTarget addEventListener method.
                //       Could be useful if some event's handler calls stopPropagation method preventing event bubbling.
                capture: true
            },
        }
    },
    emits: ['onShow', 'onHide'],
    methods: {


        clickInside() {
            this.lastClickInside = Date.now()
            if (this.closeOnClickInside) {
                this.open = false
            }
        },
        toggle() {
            // console.log("TOGGLE", this.open)
            if (!this.open) {
                this.$refs.panel.style.opacity = 0
                this.lastOpen = Date.now()
                setTimeout(function () {
                    let topNav = 160
                    let top = this.$refs.panel.getBoundingClientRect().top
                    let intViewportHeight = window.innerHeight
                    let panelHeight = this.$refs.panel.getBoundingClientRect().height
                    if (top - panelHeight > topNav) {
                        if (top + panelHeight > intViewportHeight) {
                            this.$refs.panel.style.top = (-panelHeight - 20) + "px"
                        } else {
                            this.$refs.panel.style.top = "auto"
                        }
                    } else {
                        this.$refs.panel.style.top = "auto"
                    }
                    this.$refs.panel.style.opacity = 100
                }.bind(this), 100)
            } else {
                setTimeout(function () {
                    this.$refs.panel.style.top = "auto"
                    this.$refs.panel.style.opacity = 0
                }.bind(this), 100)
            }
            this.open = !this.open
        },
        close() {
            this.open = false
            setTimeout(function () {
                if (this.$refs.panel) {
                    this.$refs.panel.style.top = "auto"
                }
            }.bind(this), 100)
        },
        clickOutside(event) {
            const parentElement = this.$refs.trigger
            const childElement = event.target
            const position = parentElement.compareDocumentPosition(childElement);
            if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                //console.log('childElement is inside parentElement')
                return false
            }
            // console.log("clickOutside", event.target, this.$refs.trigger.firstChild)
            return this.open && Date.now() - this.lastClickInside > 200
        },
        clickOutsideHandler(event) {
            //console.log("clickOutsideHandler")
            if (this.open) {
                if (Date.now() - this.lastOpen > 200) {
                    this.close()
                    // this.open = false
                    // setTimeout(function() {
                    //     this.$refs.panel.style.top = "auto"
                    // }.bind(this),100)
                }
            }
        },
        // dispatch() {
        //     console.log("open is ", this.open)
        // }
    },

    // mounted() {
    //     this.open = true
    //     setTimeout(function() {
    //         let topNav = 160
    //         let top = this.$refs.panel.getBoundingClientRect().top
    //         let intViewportHeight = window.innerHeight
    //         let panelHeight = this.$refs.panel.getBoundingClientRect().height
    //         if (top - panelHeight > topNav) {
    //             if (top+panelHeight > intViewportHeight) {
    //                // console.log("REVERSE", top - panelHeight)
    //                 this.$refs.panel.style.top = (-panelHeight -20) + "px"
    //             }
    //         }
    //         this.open = false
    //         setTimeout(function() {
    //             this.initialized = true
    //         }.bind(this),100)
    //     }.bind(this),100)
    // },
    setup(props, { emit }) {
        let open = ref(false)

        const closeOnEscape = (e) => {
            if (open.value && e.keyCode === 27) {
                open.value = false
            }
        }

        //watchEffect(() => emit('stateChange', open) )


        onMounted(() => document.addEventListener('keydown', closeOnEscape))
        onUnmounted(() => document.removeEventListener('keydown', closeOnEscape))

        return {
            open,
        }
    },
    watch: {
        open(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal) {
                    this.$emit('onShow')
                } else {
                    this.$emit('onHide')
                }
            }
        }
    },

    // watch: {
    //     open(newVal, oldVal) {
    //         if (newVal != oldVal) {
    //             if (newVal) {
    //                 this.$emit("show")
    //             } else {
    //                 this.$emit("hide")
    //             }
    //         }
    //     }
    // },


    computed: {
        widthClass() {
            return 'w-' + this.width.toString()
            // return {
            //     '48': 'w-48',
            // }[this.width.toString()]
        },

        alignmentClasses() {
            if (this.align === 'left') {
                return 'origin-top-left left-0'
            } else if (this.align === 'right') {
                return 'origin-top-right right-0'
            } else if (this.align === 'bottom') {
                return 'origin-bottom-left left-0'
            } else if (this.align === 'bottom-r') {
                return 'origin-bottom-right right-0'
            } else {
                return 'origin-top'
            }
        },

        zClasses() {
            return this.open ? 'z-30' : 'z-0'
        },

        heightClasses() {
            return this.open ? 'h-auto' : 'h-0'
        }
    }
}
</script>

<style scoped>
.tagsMenu {
    transition: transform 0.2s ease-out;
}
</style>
